import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function AuthorityNumbersSection() {
  const stats = [{
    number: '+1.500',
    desc: 'profesores y entrenadores lo usan'
  }, {
    number: '+140',
    desc: 'ejercicios analizados'
  }, {
    number: '4.9/5 ⭐',
    desc: 'calificación'
  }];
  return <section className="py-8 bg-card-dark border-y border-card-border-dark" data-id="element-1">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-2">
        <div className="grid grid-cols-3 gap-8 md:gap-4 text-center" data-id="element-3">
          {stats.map((stat, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-4">
              <div className="flex flex-col items-center justify-center h-full" data-id="element-5">
                <div className="text-4xl md:text-5xl font-black text-primary font-heading mb-2" data-id="element-6">
                  {stat.number}
                </div>
                <p className="text-sm md:text-base text-gray-400 max-w-[200px] mx-auto" data-id="element-7">
                  {stat.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}